<template>
  <div class="max-h-full overflow-y-auto p-4 md:px-6">
    <slot />
  </div>
</template>
